export default {
  registration: {
    header: {
      title: '専用登録ページ',
      title_esg_data_share: 'ESGデータシェア登録ページ',
    },
    passcode: {
      section_one: 'こちらは本サービスの利用を依頼された企業様向けの専用登録ページとなります。',
      section_two: '連携されたパスコードを入力して進んでください。',
      section_three: 'パスコードがわからない場合は、貴社に本サービスの利用を依頼した企業まで問い合わせください。',
      passcode: '閲覧用パスコード',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: '入力内容に不備があります。',
      unexpected_error: '予期せぬエラーが発生しました',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'ご担当者のメールアドレスをご入力ください。',
      email: 'メールアドレス',
      email_placeholder: 'メールアドレスを入力してください',
    },
    sent: {
      section_one: '入力いただいたメールアドレスへメールをお送りしました。',
      section_two: 'ご確認の上、メール内のURLから登録にお進みください。',
      section_three: '30分経ってもメールが届いていない場合は、',
      section_four: 'までお知らせください。',
    },
    password: {
      section_one: '入力されたメールアドレスは、すでにアスエネ関連プロダクトのアカウントを登録済みです。',
      section_two: 'ご登録されているパスワードをご入力ください。',
      password: 'パスワード',
      password_placeholder: 'パスワードを入力してください',
      error_auth: '認証に失敗しました。再ログインしてください。',
      error_linking: '認証に失敗しました。再度パスワードを入力してください。',
      same_domain_modal: {
        title: '@:registration.form.same_domain_modal.title',
        section: '入力されたメールアドレスと同じドメインのメールアドレスのアスエネESGアカウントで、すでに該当の調査票/サーベイは登録されています。\nこのまま登録してよろしいですか？',
      },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: '貴社の会社情報やご担当名等をご入力ください。',
      section_three: 'お申し込み後に登録済みのアカウントでログインいただきますと、依頼された調査票/サーベイへの回答が可能となります。',
      buyer_name: '評価依頼元企業名',
      expires_date: '登録ページの有効期限',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: '法人名',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: '山田',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: '太郎',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: '※入力されたメールアドレスが表示されています',
      phone: 'ご連絡可能な電話番号',
      phone_placeholder: '0000000000',
      locale: '言語選択',
      section_one: '',
      rule: '利用規約',
      rule_link: '/pdf/241112_③ESG評価クラウド_利用規約_サプライヤー向け（バイヤー経由）.pdf',
      punctuation: '、',
      policy: '個人情報保護方針',
      policy_link: 'https://asuene.com/privacy',
      section_two: 'に同意の上でお進みください。',
      same_domain_modal: {
        title: '登録アカウントの確認',
        section: '入力されたメールアドレスと同じドメインのメールアドレスで、すでにアスエネESGのアカウントが登録されています。\nこのままアカウントを作成してよろしいですか？',
      },
    },
    thanks: {
      section_one: 'お申し込みありがとうございます',
      section_two: '入力いただいたメールアドレスへ、ログインIDとパスワードをお送りしました。',
      section_three: 'ご確認いただき、メール内容に従ってログインしてください。',
      section_four: '30分経ってもメールが届いていない場合は、',
      section_five: '@:registration.expired.section_three',
      section_six: '',
    },
    expired: {
      section_one: 'ご指定のURLはすでに有効期限が過ぎています。',
      section_two: 'ご利用をご希望の場合は、',
      section_three: 'までお知らせください。担当者より改めてご連絡します。',
    },
    error: {
      section_one: 'ご指定のURLが見つかりませんでした。',
      section_two: 'お手数をおかけいたしますが、再度URLのご確認をお願いいたします。',
    },
    btn: {
      submit: '送信する',
      service_top: 'サービストップ',
      login: 'ログインする',
      register: '登録する',
      rating_url: 'https://asuene.com/rating',
    },
    buyer: {
      sharing_company: '共有元企業名',
      explain_message: 'お申し込み後に登録済みのアカウントでログインいただきますと、共有されたESGデータの閲覧が可能となります。',
    },
    share_answer: {
      verify_title: '回答閲覧認証',
      description_1: '{company}の調査票/サーベイの回答はパスワードで保護されています。',
      description_2: '閲覧するにはパスワードを入力してください。',
    },
  }
}
